
import { AppProvider } from 'contexts/TimerAppContexts/AppContext'
import React from 'react';
import { TimerAppUI } from './TimerAppUI';

import { TimerModal } from 'components/TimerApp/Timer/TimerModal'
import { TodoProvider } from 'contexts/TimerAppContexts/TodoContext'
import { ClockProvider } from 'contexts/TimerAppContexts/ClockContext';

import 'stylesheets/TimerAppStyles/TimerApp.css'

function TimerApp() {

  return (
    <>
      <AppProvider>
        <TodoProvider>
          <div className="timer-app">
            <TimerAppUI />
            <ClockProvider secondsWork={10} secondsBreak={5} secondsLongBreak={7}>
              <TimerModal>
              </TimerModal>
            </ClockProvider>
          </div>
        </TodoProvider >
      </AppProvider>
    </>
  );
}

export default TimerApp;
